import { faUsers, faGem, faComment, faCog, faChartBar, faBookOpen, faInbox, faQuestionCircle, faEllipsisH } from '@fortawesome/pro-light-svg-icons';

const master = {
  guide: {
    title: '初心者ガイド',
    description: 'SocialDogの使い方やサービス全般',
    icon: faBookOpen,
    children: {
      introduction: {
        title: 'SocialDogとは'
      },
      howto_to_use: {
        title: 'SocialDog活用法'
      },
      manual: {
        title: 'SocialDogを活用したTwitter運用マニュアル'
      },
      operation: {
        title: 'Twitter運用のコツ'
      },
      safety: {
        title: '安全に使うために'
      },
      support: {
        title: 'サポート'
      },
    }
  },
  faq: {
    title: 'よくある質問',
    description: '困った時やトラブルシューティング',
    icon: faQuestionCircle,
    children: {
      service: {
        title: 'サービス全般'
      },
      tweet_management: {
        title: 'ツイート'
      },
      user_list: {
        title: '受信箱・フォロワー・ツイートへの反応'
      },
      analytics: {
        title: '分析'
      },
    }
  },
  tweet_management:
    {
      title: 'ツイート',
      description: '予約ツイートやRSSからの自動投稿など',
      icon: faComment,
      children: {
        introduction: {
          title: 'ツイート管理について'
        },
        scheduled_tweet: {
          title: '予約投稿をする'
        },
        queue: {
          title: '予約枠を使う'
        },
        rss_tweet: {
          title: 'RSS自動投稿を使う'
        },
        csv_import: {
          title: '一括予約'
        },
        calendar_export: {
          title: 'カレンダーエクスポート'
        },
        quick: {
          title: 'クイックツイート'
        },
        hashtags: {
          title: 'ハッシュタグ検索'
        },
      }
    },
  user_list:
    {
      title: '受信箱・フォロワー・ツイートへの反応',
      description: 'キーワードモニター、メンション、フォロー、フォロー解除、ツイートへの反応など',
      icon: faUsers,
      children: {
        keyword_monitor: {
          title: 'キーワードモニター'
        },
        tweet: {
          title: 'ツイートへのアクション'
        },
        introduction: {
          title: 'フォロワーについて'
        },
        tweet_engagement: {
          title: 'ツイートへの反応'
        },
        filter: {
          title: 'フィルタでユーザーを絞り込む'
        },
        csv_download: {
          title: 'CSVダウンロード'
        },
        action: {
          title: 'ユーザーにアクションする'
        },
      }
    },
  analytics:
    {
      title: '分析',
      description: 'フォロワー分析、ツイート分析など',
      icon: faChartBar,
      children: {
        introduction: {
          title: '分析について'
        },
        tweets: {
          title: 'ツイート分析'
        },
        get_followers: {
          title: 'フォロワー獲得分析'
        },
        followers: {
          title: 'フォロワー分析'
        },
        report: {
          title: 'レポート'
        },
      }
    },
  paid_plan: {
    title: '有料プラン',
    description: 'プランとアップグレード、お支払いとご請求など',
    icon: faGem,
    children: {
      plan: {
        title: 'プランとアップグレード'
      },
      payment: {
        title: 'お支払いとご請求'
      },
    },
  },
  account:
    {
      title: '設定',
      description: 'Twitterアカウント連携、通知設定など',
      icon: faCog,
      children: {
        twitter: {
          title: 'Twitterアカウントの連携'
        },
        team: {
          title: 'チーム'
        },
        socialdog: {
          title: 'SocialDogアカウント'
        },
        settings: {
          title: '設定'
        },
      }
    },
  other: {
    title: 'アップデート・お知らせ',
    description: 'アップデート情報、お知らせ、メンテナンス情報など',
    icon: faEllipsisH,
    children: {
      update: {
        title: 'リリース・アップデート情報'
      },
      notice: {
        title: 'お知らせ・メンテナンス'
      },
      guideline: {
        title: 'ガイドライン'
      },
    }
  },
};
export default master;

export const theme_categories = {
  guide: master.guide,
  faq: master.faq,
};

export const function_categories = {
  tweet_management: master.tweet_management,
  user_list: master.user_list,
  analytics: master.analytics,
  paid_plan: master.paid_plan,
  account: master.account,
  other: master.other,
};

export const nav_bar = {
  guide: {
    title: '初心者ガイド',
  },
  faq: {
    title: 'よくある質問',
  },
  functions: {
    title: '機能の使い方・活用術',
    children: {
      tweet_management: {
        title: 'ツイート',
        icon: faComment,
      },
      user_list: {
        title: '受信箱・フォロワー・ツイートへの反応',
        icon: faUsers,
      },
      analytics: {
        title: '分析',
        icon: faChartBar,
      },
      paid_plan: {
        title: '有料プラン',
        icon: faGem,
      },
      account: {
        title: '設定',
        icon: faCog,
      },
    }
  }
};

export function get_title(paths) {
  if (paths.length === 1) {
    if (!(paths[0] in master)) {
      console.log(paths + '見つかりません');
    }
    return master[paths[0]].title;
  }
  if (paths.length === 2) {
    if (!(paths[1] in master[paths[0]].children)) {
      console.log(paths + '見つかりません');
    }
    return master[paths[0]].children[paths[1]].title;
  }
}